import { APIService } from '../../api/apiService';
import type { EntityAccessMap, TagAccessDetails } from '../../interfaces/AccessMap';

export class AccessMapService extends APIService {
  private readonly basePath = '/accessmap';

  getTagAccess(tagId: number): Promise<TagAccessDetails> {
    return this.request(`${this.basePath}/tag/${tagId}`, 'GET');
  }

  getUserAccessMap(userId: number): Promise<EntityAccessMap> {
    return this.request(`${this.basePath}/user/${userId}`, 'GET');
  }

  getGroupAccessMap(groupId: number): Promise<EntityAccessMap> {
    return this.request(`${this.basePath}/group/${groupId}`, 'GET');
  }
}
